<template>
  <div
    id="app"
    style="overflow: hidden"
    :style="{
      background:
        $route.path == '/report' ? '' : 'url(' + $images.background_bg + ')',
      backgroundSize: '100%',
    }"
  >
    <router-view />
  </div>
</template>

<script>
import {
  getUserAESinfo
} from "./api/index";
export default {
  name: "App",
  data() {
    return {
      resizeFn: null,
    };
  },
  mounted() {
    getUserAESinfo().then(data=>{
      if(data.code == 200){
        sessionStorage.setItem('YQ_USER_SECRET', data.data);
      }
    })
    const documentWidth = document.body.offsetWidth;
    const ratio = documentWidth / 1920;
    // if (documentWidth > 1920) {
    //   document.body.style.transform = `scale(${ratio}, ${ratio})`;
    // }
    this.resizeFn = this.$debounce(function () {
      // location.reload();
      return;
      const documentWidth = document.body.offsetWidth;
      const ratio = documentWidth / 1920;
      if (documentWidth > 1920) {
        document.body.style.transform = `scale(${ratio}, ${ratio})`;
      }
    }, 200);
    window.addEventListener("resize", this.resizeFn);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.resizeFn);
  },
};
</script>

<style lang="less">
html,
body {
  height: 100%;
  width: 100%;
  padding: 0;
  margin: 0;
}
html {
  font-size: 20px;
}
body {
  transform-origin: left top;
  background-size: 100% 100%;
}
#app {
  width: 100%;
  height: 100%;
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.angle {
  background: rgba(87, 87, 87, 0.3);
  border: 1px solid #4d4a48;

  .angleSon {
    width: 100%;
    height: 100%;
    background: linear-gradient(to left, #bf9d63, #bf9d63) left top no-repeat,
      linear-gradient(to bottom, #bf9d63, #bf9d63) left top no-repeat,
      linear-gradient(to left, #bf9d63, #bf9d63) right top no-repeat,
      linear-gradient(to bottom, #bf9d63, #bf9d63) right top no-repeat,
      linear-gradient(to left, #bf9d63, #bf9d63) left bottom no-repeat,
      linear-gradient(to bottom, #bf9d63, #bf9d63) left bottom no-repeat,
      linear-gradient(to left, #bf9d63, #bf9d63) right bottom no-repeat,
      linear-gradient(to left, #bf9d63, #bf9d63) right bottom no-repeat;
    background-size: 1px 20px, 20px 1px, 1px 20px, 20px 1px;
    padding: 20px;
  }
}
.nooverHeight {
  height: 100%;
  overflow-y: auto;
  &::-webkit-scrollbar {
    width: 0px;
    height: 0px;
  }

  &::-webkit-scrollbar-track {
    background-color: transparent;
    -webkit-border-radius: 0em;
    -moz-border-radius: 0em;
    border-radius: 0em;
  }
  &::-webkit-scrollbar-thumb {
    background-color: rgb(147, 147, 153, 0.5);
    -webkit-border-radius: 0em;
    -moz-border-radius: 0em;
    border-radius: 0em;
  }
}
.overHeight {
  height: 100%;
  overflow-y: auto;
  &::-webkit-scrollbar {
    width: 2px;
    height: 2px;
  }

  &::-webkit-scrollbar-track {
    background-color: transparent;
    -webkit-border-radius: 2em;
    -moz-border-radius: 2em;
    border-radius: 2em;
  }
  &::-webkit-scrollbar-thumb {
    background-color: rgb(147, 147, 153, 0.5);
    -webkit-border-radius: 2em;
    -moz-border-radius: 2em;
    border-radius: 2em;
  }
}
</style>
